module.exports = __webpack_public_path__ + "static/media/close_small.c696c9cf.webp";